import React from "react";
import { Text } from "@salestrak/ui";
import { EntityTag } from "#app/components/entity";
import type { ActivityChange } from "../activity-types";
import { DEFAULT_ISSUE_NAME } from "../activity-types";

interface TypeChangeChunkProps {
  change: ActivityChange;
}

export function TypeChangeChunk({ change }: TypeChangeChunkProps) {
  const oldType = change.oldType;
  const newType = change.newType;

  return (
    <Text size="sm">
      changed this {DEFAULT_ISSUE_NAME.toLowerCase()} type
      {oldType && newType ? (
        <Text size="sm">
          {" "}
          from{" "}
          <EntityTag
            entity={{
              kind: "issueType",
              id: oldType.issueTypeId,
              issueType: oldType,
            }}
            display="label"
            weight="semibold"
            as="text"
          />
        </Text>
      ) : null}
      {newType ? (
        <Text size="sm">
          {" "}
          to{" "}
          <EntityTag
            entity={{
              kind: "issueType",
              id: newType.issueTypeId,
              issueType: newType,
            }}
            display="label"
            weight="semibold"
            as="text"
          />
        </Text>
      ) : null}
    </Text>
  );
}
